import { createAsyncThunk } from "@reduxjs/toolkit";

import CameraAPI from "~/common/apis/CameraAPI";

export const getCameraFovImage = createAsyncThunk(
  "camerasFov/getCameraFovImage",
  async ({ deviceId, poiDegrees }) => {
    const { data } = await CameraAPI.getFovImage(deviceId, poiDegrees);

    return {
      fovImage: data,
      poiDegrees,
      deviceId
    };
  }
);
